import React from 'react';
import Icon from '../../Icon/components/Icon';

const SmallSectionTitleIcon = (props) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <line x1="4" y1="6" x2="20" y2="6" strokeWidth="2.5"/>
      <line x1="4" y1="11" x2="20" y2="11"/>
      <line x1="4" y1="16" x2="20" y2="16"/>
      <line x1="4" y1="21" x2="20" y2="21"/>
    </Icon>
  );
};

export default SmallSectionTitleIcon;
